// extracted by mini-css-extract-plugin
export default {"amenities":"_1JKEBjYdsniYDwnS-HtG-K","contentToggle":"_2_uf7saAkM0fi1BBoE6FN","icons":"_3887D6L6xk-Q1iD8DXNYlR","amenityIcons":"_3uu7hib3GX94XexwYWEEOd"};